const SUCCESS_CODE = [200,201,204];

export {
    SUCCESS_CODE
}